/**
 * Canonical Estimate/Contract labor list order (matches labor catalog / worksheet).
 * Names not in this list render after, alphabetically.
 */
export const LABOR_DISPLAY_ORDER: readonly string[] = [
    "Tear off/ Install",
    "Additional Layers",
    "Wood Tear off",
    "Mod Bit Tear off install",
    "Ice & Water Shield",
    "Install Decking",
    "Install decking - steep",
    "Steep Charge 7/12 - 9/12",
    "Steep Charge 10/12 - 12/12",
    "Steep Charge Over 12/12",
    "Hand carry Shingles",
    "Gutter Removal",
    "Flash Chimney (Brick)",
    "Flash Chimney (Wood)",
    "Flash Cooler",
    "Replace Skylight (Curb)",
    "Replace Skylight (Deck)",
    "Flash Skylight",
    "RV cut in/Patch",
    "Ridge vent cut in per LF",
    "Build Cricket",
    "Carry bundle up ladder",
    "Trip Charge",
    "No Access",
    "Gutter Install",
    "Downspout install",
    "Gutter Screens",
    "Other Gutter/DS/ETC",
    "EPDM",
    "Solar",
    "Prep&Prime paint Exterior",
    "Handrail",
    "Deck",
    "Trim, Soffit & Siding",
    "Exterior Carpentry",
    "Window Trim",
    "Shutters",
    "Garage Door",
    "Garage Door Trim",
    "Window Screens",
    "Patio Screens",
    "Stucco",
    "Carry Debris",
    "Prime, Prep &Paint Interior",
    "Mask& Prep for paint",
    "Content Manipulation Fee",
    "Trim, Walls",
    "R&R Bath Fixtures",
    "R&R Insulation",
    "R&R Drywall",
    "R&R Suspended Ceiling",
    "R&R Electric",
    "Plumbing",
    "Fence",
    "Misc. Labor",
] as const;

const laborOrderIndex = new Map(
    LABOR_DISPLAY_ORDER.map((name, index) => [name, index]),
);

export function compareLaborDisplayOrder(aName: string, bName: string): number {
    const aIndex = laborOrderIndex.get(aName);
    const bIndex = laborOrderIndex.get(bName);
    const aRank = aIndex === undefined ? Number.MAX_SAFE_INTEGER : aIndex;
    const bRank = bIndex === undefined ? Number.MAX_SAFE_INTEGER : bIndex;
    if (aRank !== bRank) return aRank - bRank;
    return aName.localeCompare(bName);
}

export function sortLaborRowsByDisplayOrder<T extends { name: string }>(
    rows: T[],
): T[] {
    return [...rows].sort((a, b) => compareLaborDisplayOrder(a.name, b.name));
}
